import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Formik} from "formik";
import {BootstrapError, BootstrapField} from "../../helpers/Field";
import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup.string().email().required("Email is required."),
  firstName: yup.string().required("First Name Required."),
  lastName: yup.string().required("Last Name Required."),
  company: yup.string().required("Company Required."),
  message: yup.string().required("Message Required."),
});

class RegistrationRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestComplete: false,
      errorMessage: null,
    }
  }

  render() {
    return (
      <div>
        {!this.state.requestComplete && <Formik
          validationSchema={schema}
          onSubmit={(props, bag) => {
            this.props.submit(props).then(() => {
              this.setState({requestComplete: true});
            });
          }}
          render={props =>
              <div className="card">
            <form onSubmit={props.handleSubmit}>
              <div className="row">
                <div className={"col-12"}>
                  <div className="form-group">
                    <label>Email</label>
                    <BootstrapField type={"email"} name={"email"}/>
                    <BootstrapError name={"email"}/>
                  </div>
                  <div className="form-group">
                    <label>First Name</label>
                    <BootstrapField type={"text"} name={"firstName"}/>
                    <BootstrapError name={"firstName"}/>
                  </div>
                  <div className="form-group">
                    <label>Last Name</label>
                    <BootstrapField type={"text"} name={"lastName"}/>
                    <BootstrapError name={"lastName"}/>
                  </div>
                  <div className="form-group">
                    <label>Company</label>
                    <BootstrapField type={"text"} name={"company"}/>
                    <BootstrapError name={"company"}/>
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <BootstrapField component={"textarea"} name={"message"}/>
                    <BootstrapError name={"message"}/>
                  </div>
                  <div className={"form-group"}>
                    <button type={"submit"} className={"btn btn-primary"}>Submit</button>
                  </div>
                </div>
              </div>
            </form>
            </div>
          }/>}
        {this.state.requestComplete && <React.Fragment>
        <div className="card">
          <div>
            Thanks for submitting a registration request. We will get back with your shortly.
          </div>
        </div>
            
        </React.Fragment>
        }
      </div>
    );
  }
}

RegistrationRequestForm.propTypes = {
  // submit: PropTypes.func.isRequired,
};

export default RegistrationRequestForm;
